<template>
    <ContentPage title="Politica de Confidențialitate" sub-title="În conformitate cu art. 13 din Regulamentul (UE) 2016/679">
        <p>
            Adorea S.r.l. (Fleequid), cu sediul în Via provinciale per Bizzarone, 43 – 22077 Olgiate Comasco (CO), CIF și CF 04114790134, înscrisă în
            Registrul Comerțului din Como la numărul 04114790134, capital social 10.000,00€ v.i. („
            <strong>Adorea S.r.l. (Fleequid)</strong>") în calitate de operator al datelor, vă furnizează prezenta informare privind prelucrarea
            datelor dumneavoastră cu caracter personal în conformitate cu Art. 13 din Regulamentul (UE) nr. 2016/679 („<strong>GDPR</strong>").
        </p>

        <BaseVerticalStack as="ol" class="list-inside list-decimal">
            <li>
                <h3 class="text-highlighted inline-block font-bold">Scopul prelucrării și temeiul juridic</h3>
                <p class="my-4">
                    Adorea S.r.l. (Fleequid) este o societate care se ocupă de gestionarea licitațiilor online relative la vehicule industriale,
                    destinate unei clientele business. Când o societate se înregistrează pe Adorea S.r.l. (Fleequid) pentru a participa la o
                    licitație, i se va solicita să indice anumite date ale referentului respectiv, și anume nume, prenume, e-mail și număr de telefon
                    („<strong>Date</strong>"). Aceste date vor fi prelucrate de Adorea S.r.l. (Fleequid), inclusiv prin intermediul unor instrumente
                    electronice/digitale, exclusiv pentru următoarele scopuri și temeiuri juridice:
                </p>
                <div class="my-4 grid grid-cols-[40px_1fr_1fr] grid-rows-[24px_1fr_1fr] gap-2">
                    <div class="font-bold">Nr.</div>
                    <div class="font-bold">Scop</div>
                    <div class="font-bold">Temei juridic</div>
                    <div class="font-bold">1.1</div>
                    <div>
                        Permiterea participării la licitație conform solicitării utilizatorului, garantând desfășurarea normală și posibilitatea de a
                        contacta referentul societății în caz de adjudecare
                    </div>
                    <div>Executarea contractului</div>
                    <div class="font-bold">1.2</div>
                    <div>Trimiterea de materiale informative referitoare la serviciile Adorea S.r.l. (Fleequid)</div>
                    <div>
                        Interes legitim, în baza art. 130, alineatul 4, din d.lgs. 196/2003. Persoana vizată se poate opune în orice moment
                        prelucrării, în mod simplu și gratuit.
                    </div>
                </div>
                <p class="my-4">
                    Furnizarea Datelor cu Caracter Personal este esențială pentru participarea la licitație și pentru utilizarea serviciilor Adorea
                    S.r.l. (Fleequid), iar nefurnizarea acestora ar prejudicia astfel această participare și stabilirea raportului contractual cu
                    Adorea S.r.l. (Fleequid).
                </p>
            </li>
            <li>
                <h3 class="text-highlighted inline-block font-bold">Comunicarea și transferul Datelor</h3>
                <p class="my-4">
                    Datele pot fi prelucrate și de societățile contractante care desfășoară activități conexe, instrumentale sau de sprijin față de
                    cele ale Adorea S.r.l. (Fleequid) și de care Adorea S.r.l. (Fleequid) se poate folosi pentru executarea scopurilor indicate mai
                    sus. Aceștia vor acționa în calitate de persoane împuternicite, conform instrucțiunilor Adorea S.r.l. (Fleequid). În cazul în
                    care, la partajarea informațiilor, Datele ar fi transferate în țări din afara Spațiului Economic European, Adorea S.r.l.
                    (Fleequid) se va asigura că Datele sunt transferate în conformitate cu prezenta politică de confidențialitate și conform
                    prevederilor reglementărilor aplicabile privind protecția datelor.
                </p>
            </li>
            <li>
                <h3 class="text-highlighted inline-block font-bold">Păstrarea Datelor</h3>
                <p class="my-4">
                    Datele dumneavoastră vor fi păstrate pentru perioada strict necesară îndeplinirii scopurilor menționate la punctul 1 de mai sus,
                    și anume 10 ani de la încetarea efectelor contractului. Această perioadă de păstrare este justificată, în ceea ce privește
                    scopurile de marketing, de natura particulară a bunurilor care fac obiectul licitațiilor gestionate de Adorea S.r.l. (Fleequid),
                    și anume vehicule industriale de mare valoare. Odată trecut acest termen, Datele vor fi șterse sau anonimizate.
                </p>
            </li>
            <li>
                <h3 class="text-highlighted inline-block font-bold">Drepturile persoanei vizate</h3>
                <p class="my-4">
                    Puteți exercita în orice moment dreptul de acces la propriile Date și la următoarele informații: scopul prelucrării; categoriile
                    de date cu caracter personal în cauză; destinatarii sau categoriile de destinatari cărora le pot fi comunicate datele; dacă este
                    posibil, perioada de păstrare a datelor, conform prevederilor art. 15 GDPR; dreptul de rectificare a datelor cu caracter personal
                    inexacte conform art. 16 GDPR; dreptul de a obține ștergerea datelor care vă privesc, în cazul în care sunt îndeplinite condițiile
                    art. 17 GDPR; dreptul de a solicita restricționarea prelucrării, în cazul în care sunt îndeplinite condițiile art. 18 GDPR;
                    dreptul la portabilitatea datelor în cazul în care sunt îndeplinite condițiile art. 20 GDPR; dreptul de a se opune prelucrării,
                    inclusiv prelucrării în scopuri de marketing, în cazul în care sunt îndeplinite condițiile art. 21 GDPR. De asemenea, puteți
                    oricând depune o plângere la Autoritatea Garantă pentru Protecția Datelor cu Caracter Personal conform modalităților ilustrate pe
                    site-ul
                    <NuxtLink class="text-primary hover:underline" to="https://www.garanteprivacy.it" target="_blank" external>
                        www.garanteprivacy.it</NuxtLink
                    >.
                </p>
                <p class="my-4">
                    Pentru a efectua solicitări sau întrebări cu privire la practicile noastre în materie de confidențialitate, vă invităm să ne
                    contactați la adresa <FleequidEmailLink type="privacy" />. Răspundem tuturor solicitărilor utilizatorilor care doresc să își
                    exercite drepturile în materie de protecție a datelor cu caracter personal în conformitate cu legislația în vigoare privind
                    protecția datelor.
                </p>
            </li>
        </BaseVerticalStack>
    </ContentPage>
</template>
